/**
 * Build address string from location object for geocoding.
 * Normalises common field-name variants (address/address1, zip/postalCode)
 * before assembling the parts.
 * @param {Object} location - Location object
 * @returns {string} - Formatted address string
 */
export const buildAddressString = (location) => {
	const street = location.address1 || location.address || '';
	const postal = location.postalCode || location.zip || '';

	return [
		street,
		location.address2,
		location.address3,
		location.city,
		location.state,
		postal,
		location.country
	]
		.filter(Boolean)
		.join(', ');
};
